import { EstateApplicationStageType } from './enums';
import { ApplicationId, EstateId, UserId } from './types';

export class EstateApplication {
  constructor(
    public readonly id: ApplicationId,
    public readonly tenantUserId: UserId,
    public readonly estateId: EstateId,
    public readonly stage: EstateApplicationStage,
    public readonly source?: string
  ) {}
}

export class EstateApplicationModel {
  static canAddCotenant = (estateApplication: EstateApplication): boolean =>
    [
      EstateApplicationStageType.APPROVED,
      EstateApplicationStageType.PRE_APPROVED,
    ].some((status) => estateApplication.stage.kind === status);

  static isExpired = (estateApplication: EstateApplication): boolean =>
    EstateApplicationStageType.EXPIRED === estateApplication.stage.kind;

  static isCotenantAlreadyAdded = (
    estateApplication: EstateApplication,
    cotenant: UserId
  ): boolean =>
    estateApplication.stage.coTenants.some(
      (addedCotenant) => addedCotenant === cotenant.value
    );
}

export type EstateApplicationStage = {
  kind: EstateApplicationStageType;
  coTenants: number[];
  bondPayment?: number;
  tenantCreditStudy?: string;
  rejectionReason?: RejectionReason;
  requirement?: ApplicationRequirement;
  expiredAt?: number;
};

export enum RejectionReason {
  LOW_SCORE = 'LOW_SCORE',
  REPORTED_DELINQUENCY = 'REPORTED_DELINQUENCY',
}

export type ApplicationRequirement = {
  name: string;
  bondPaymentPercentage?: number;
};
